export default "__VITE_ASSET__Ckntg4H0__"